import apiClient from './api';

export const getLatestBriefing = async () => {
  try {
    const response = await apiClient.get('/api/daily-briefing');
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      throw new Error('No briefing available');
    }
    throw new Error(
      error.response?.data?.detail || 'Failed to fetch daily briefing'
    );
  }
};

export const generateBriefing = async ({ force = false } = {}) => {
  try {
    const response = await apiClient.post('/api/daily-briefing/generate', null, {
      params: force ? { force: true } : {},
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || 'Failed to generate briefing'
    );
  }
};

export const saveItem = async (briefingId, themeIndex, itemIndex) => {
  try {
    const response = await apiClient.post(
      `/api/daily-briefing/${briefingId}/save-item`,
      { theme_index: themeIndex, item_index: itemIndex }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || 'Failed to save item'
    );
  }
};
